import { ACTIONS } from '@/store/action-types'
export const albumCatalogViewModel = {
  name: 'AlbumCatalog',
  created () {
    let params = {userid: this.$store.state.myapp.userName}
    this.$store.dispatch(ACTIONS.MYAPP_USER_ALBUM_CATALOG, params)
  },
  methods: {
    getId (id, name) {
      localStorage.setItem('albumCatalogId', id);
      localStorage.setItem('albumCatalogName', name);
    },
    remove (id) {
      let params = {id: id};
      $.ajax({
        // url: 'http://localhost:8080/myapp-backend/api/albumCatalog/remove',
        url: '/myapp-backend/api/albumCatalog/remove',
        type: 'POST',
        context: this,
        data: JSON.stringify(params),
        processData: false,
        contentType : 'application/json;charset=UTF-8',
        success: function (data) {
          let params = {userid: this.$store.state.myapp.userName}
          this.$store.dispatch(ACTIONS.MYAPP_USER_ALBUM_CATALOG, params)
        }
      });
    }
  }
}
export default {
  albumCatalogViewModel
}



// WEBPACK FOOTER //
// ./src/view-model/AlbumCatalog.js